export default __webpack_public_path__ + "static/media/log-actividad.2956abc4.png";